"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
require("react-responsive-modal/styles.css");
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _MorningstarWidget = _interopRequireDefault(require("../MorningstarWidget/MorningstarWidget"));
var _brokers = _interopRequireDefault(require("./brokers"));
var _primeQrCode = _interopRequireDefault(require("./primeQrCode"));
require("./BuyFund.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCircleNotch);
const EVENT_CATEGORY = 'etf';
const EVENT_ACTION_BUY = 'etf buy';
const EVENT_ACTION_LAUNCH = 'etf broker';
const EVENT_ACTION_COMPARE = 'etf compare';
const WT_DIVISIONS = {
  US: 1,
  USDigital: 3
};
const CompareButton = _ref => {
  let {
    ticker,
    dataspanApiUrl,
    wtRegion,
    handleCompareClick
  } = _ref;
  const [fundExists, setFundExists] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!ticker) return;
    const request = {
      method: 'GET',
      url: "".concat(dataspanApiUrl, "/fundchar/typeahead/"),
      params: {
        q: ticker,
        wtRegion
      }
    };
    const checkFundExists = async () => {
      try {
        const response = await (0, _axios.default)(request);
        if (response.status === 200) {
          setFundExists(true);
        }
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setFundExists(false);
        }
        console.log(e);
      }
    };
    checkFundExists();
  }, [ticker, dataspanApiUrl, wtRegion]);

  // Remove the check for fund existance (DSPAPP-307)
  // if (!fundExists) return null;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleCompareClick,
    "data-tip": true,
    "data-for": "compare-tool-tip"
  }, "COMPARE ", ticker.toUpperCase()), /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
    id: "compare-tool-tip",
    type: "light",
    className: "tooltip",
    effect: "float"
  }, "Compare funds and benchmark indexes based on fundamental characteristics, exposures, performance, and more."));
};
class BuyFund extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleBrokerClick = this.handleBrokerClick.bind(this);
    this.handleCompareClick = this.handleCompareClick.bind(this);
    this.handleSubmitWaitlist = this.handleSubmitWaitlist.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getAllowedStates = this.getAllowedStates.bind(this);
    this.openAppLink = this.openAppLink.bind(this);
    this.openWaitlistWithStates = this.openWaitlistWithStates.bind(this);
    this.state = {
      openModal: false,
      fundExists: false,
      showWaitlistSuccess: false,
      showWaitlistLoading: false,
      email: '',
      firstName: '',
      lastName: '',
      stateCode: '',
      allowedWisdomTreePrimeGeographies: null,
      allowedWisdomTreePrimeUsStates: null,
      showSelectStates: false
    };
  }

  // Get the Config for the app
  componentDidMount() {
    this.getAllowedStates();
  }

  // Handle open of modal
  handleOpenModal() {
    const {
      ticker
    } = this.props;

    // Tag the event of opening the modal when user clicks the button
    if (window.digitalData) {
      const e = {
        eventName: EVENT_ACTION_BUY,
        eventCategory: EVENT_CATEGORY,
        eventAction: EVENT_ACTION_BUY,
        eventLabel: ticker.toLowerCase(),
        type: 'CustomTagEvent'
      };
      window.digitalData.newEvent(e);
    }
    this.setState({
      openModal: true,
      showWaitlistLoading: false,
      showSelectStates: false
    });
  }

  // Handle close of modal
  handleCloseModal() {
    this.setState({
      openModal: false,
      showWaitlistLoading: false,
      showWaitlistSuccess: false
    });
  }
  handleInputChange(fieldName, event) {
    this.setState({
      [fieldName]: event.target.value
    });
  }

  // Handle submit to waitlist
  handleSubmitWaitlist(event) {
    const {
      dataspanApiUrl,
      ticker
    } = this.props;
    const {
      firstName,
      lastName,
      email,
      stateCode
    } = this.state;
    this.setState({
      showWaitlistLoading: true
    });
    const config = {
      method: 'POST',
      url: "".concat(dataspanApiUrl, "/prime/betasignup/"),
      data: {
        email,
        firstName,
        lastName,
        state: stateCode,
        country: stateCode,
        referringDomain: 'https://www.wisdomtree.com',
        referringDescription: ticker
      }
    };

    // Get the fund data from dataspan
    _axios.default.request(config).then(response => {
      if (response.status === 201) {
        this.setState({
          showWaitlistSuccess: true,
          showWaitlistLoading: false
        });
      }
    }).catch(e => {
      console.log(e);
      this.setState({
        showWaitlistLoading: false
      });
    });
    event.preventDefault();
  }

  // Get the Allowed WT Prime States list
  getAllowedStates() {
    const {
      wtprimeApiUrl
    } = this.props;
    this.setState({
      showWaitlistLoading: true
    });

    // Get the fund data from dataspan
    _axios.default.get("".concat(wtprimeApiUrl, "/wt/mobile/config/")).then(response => {
      if (response.status === 200) {
        this.setState({
          allowedWisdomTreePrimeGeographies: response.data['allowedGeographies'],
          allowedWisdomTreePrimeUsStates: response.data['allowedGeographies']['country'][0]['state']
        });
      }
    }).catch(e => {
      console.log(e);
      this.setState({
        allowedWisdomTreePrimeGeographies: null,
        allowedWisdomTreePrimeUsStates: null
      });
    });
  }

  // Handle click to compare the fund. This opens the Fund Comparison tool
  handleCompareClick() {
    const {
      ticker
    } = this.props;
    if (window.digitalData) {
      const e = {
        eventName: EVENT_ACTION_COMPARE,
        eventCategory: EVENT_CATEGORY,
        eventAction: EVENT_ACTION_COMPARE,
        eventLabel: ticker.toLowerCase(),
        type: 'CustomTagEvent'
      };
      window.digitalData.newEvent(e);
    }

    // add showcompetitor for Compare Fund button
    let FUND_COMPARISON_URL = '/tools#fund-comparison&tickers=[[TICKER]]&showcompetitors=[[SHOW_COMPETITORS]]&tab=metrics';
    FUND_COMPARISON_URL = FUND_COMPARISON_URL.replace('[[TICKER]]', ticker);
    if (this.props.showCompetitors === true) {
      FUND_COMPARISON_URL = FUND_COMPARISON_URL.replace('[[SHOW_COMPETITORS]]', this.props.showCompetitors);
    } else {
      FUND_COMPARISON_URL = FUND_COMPARISON_URL.replace('[[SHOW_COMPETITORS]]', false);
    }
    window.open(FUND_COMPARISON_URL, '_blank');
  }

  // Handle closure of modal when broker is clicked
  handleBrokerClick(broker) {
    const {
      ticker
    } = this.props;

    // Tag the event of clicking the broker link
    if (window.digitalData) {
      const e = {
        eventName: EVENT_ACTION_LAUNCH,
        eventCategory: EVENT_CATEGORY,
        eventAction: EVENT_ACTION_LAUNCH,
        eventLabel: "".concat(broker.name, "|").concat(ticker.toLowerCase()),
        type: 'CustomTagEvent'
      };
      window.digitalData.newEvent(e);
    }
    this.setState({
      openModal: false
    });

    // Open the broker with the ticker provided
    window.open(broker.baseUrl.replace('[TICKER]', ticker.toUpperCase()).replace('[FUNDURL]', window.location.href), '_blank');
  }
  renderUsEtfs() {
    const {
      ticker,
      brokers,
      showCompare,
      showMorningstar,
      dataspanApiUrl,
      wtDivisionID,
      showMorningstarAll
    } = this.props;
    const {
      openModal
    } = this.state;

    // Set up the broker icons
    const sites = brokers.map(broker => /*#__PURE__*/_react.default.createElement("div", {
      className: "broker-icon",
      onClick: this.handleBrokerClick.bind(this, broker),
      key: broker.name
    }, /*#__PURE__*/_react.default.createElement("img", {
      height: "90px",
      src: broker.icon,
      alt: broker.name
    })));
    const compareButton = /*#__PURE__*/_react.default.createElement(CompareButton, {
      ticker: ticker,
      dataspanApiUrl: dataspanApiUrl,
      wtRegion: this.state.wtRegion,
      handleCompareClick: this.handleCompareClick
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "buy-fund-app"
    }, ticker !== 'NONE' ? /*#__PURE__*/_react.default.createElement("div", {
      className: "trade-fund"
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: this.handleOpenModal
    }, "HOW TO BUY", ' ', ticker.toUpperCase()), showCompare ? compareButton : null, showMorningstar ? /*#__PURE__*/_react.default.createElement(_MorningstarWidget.default, {
      dataspanApiUrl: dataspanApiUrl,
      ticker: ticker,
      wtRegion: "US",
      wtDivisionID: wtDivisionID,
      showMorningstarAll: showMorningstarAll
    }) : null, /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
      open: openModal === true,
      showCloseIcon: true,
      onClose: this.handleCloseModal,
      focusTrapped: false,
      classNames: {
        overlay: 'modal-overlay',
        modal: 'choose-broker-container'
      },
      closeOnOverlayClick: true,
      closeOnEsc: true,
      center: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "choose-broker"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "intro"
    }, /*#__PURE__*/_react.default.createElement("h1", null, "How Can I Buy ", ticker.toUpperCase(), "?"), /*#__PURE__*/_react.default.createElement("p", null, "This is perhaps the most common question we are asked. ETFs are traded on major stock exchanges, much like shares of common stock. They can be bought and sold throughout the trading day through a broker. Brokerage commissions and transaction costs may vary, so be sure to check on these costs with your broker, advisor, or other intermediary."), /*#__PURE__*/_react.default.createElement("p", null, "Click your broker below to trade ", ticker.toUpperCase(), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "bold-text"
    }, "You will leave the WisdomTree website when clicking any link below."), ' ', "Hyperlinks on this website are provided as a convenience and we disclaim any responsibility for information, services or products found on the websites linked hereto."), /*#__PURE__*/_react.default.createElement("p", null, "WisdomTree makes no representations, warranties, endorsements, or recommendations regarding any broker, advisor, or other financial intermediary. Ask such entities or persons about any payments from WisdomTree, which may create a conflict of interest influencing such entities or persons to recommend a WisdomTree ETF over another investment.")), /*#__PURE__*/_react.default.createElement("div", {
      className: "brokers"
    }, sites), /*#__PURE__*/_react.default.createElement("div", {
      className: "footnotes"
    }, /*#__PURE__*/_react.default.createElement("p", null))))) : null);
  }

  // Render the form for submitting beta signup
  renderWaitlistForm() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.handleSubmitWaitlist,
      className: "waitlist-form"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      value: this.state.firstName,
      onChange: event => this.handleInputChange('firstName', event),
      id: "firstName",
      placeholder: "First name",
      required: true
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      value: this.state.lastName,
      onChange: event => this.handleInputChange('lastName', event),
      id: "lastName",
      placeholder: "Last name",
      required: true
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "email",
      value: this.state.email,
      onChange: event => this.handleInputChange('email', event),
      pattern: "^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$",
      id: "email",
      placeholder: "Email address",
      required: true
    }), /*#__PURE__*/_react.default.createElement("select", {
      id: "stateCode",
      onChange: event => this.handleInputChange('stateCode', event),
      required: true
    }, /*#__PURE__*/_react.default.createElement("option", {
      value: ""
    }, "State"), /*#__PURE__*/_react.default.createElement("option", {
      value: "AL"
    }, "Alabama"), /*#__PURE__*/_react.default.createElement("option", {
      value: "AK"
    }, "Alaska"), /*#__PURE__*/_react.default.createElement("option", {
      value: "AZ"
    }, "Arizona"), /*#__PURE__*/_react.default.createElement("option", {
      value: "AR"
    }, "Arkansas"), /*#__PURE__*/_react.default.createElement("option", {
      value: "CA"
    }, "California"), /*#__PURE__*/_react.default.createElement("option", {
      value: "CO"
    }, "Colorado"), /*#__PURE__*/_react.default.createElement("option", {
      value: "CT"
    }, "Connecticut"), /*#__PURE__*/_react.default.createElement("option", {
      value: "DE"
    }, "Delaware"), /*#__PURE__*/_react.default.createElement("option", {
      value: "DC"
    }, "District Of Columbia"), /*#__PURE__*/_react.default.createElement("option", {
      value: "FL"
    }, "Florida"), /*#__PURE__*/_react.default.createElement("option", {
      value: "GA"
    }, "Georgia"), /*#__PURE__*/_react.default.createElement("option", {
      value: "HI"
    }, "Hawaii"), /*#__PURE__*/_react.default.createElement("option", {
      value: "ID"
    }, "Idaho"), /*#__PURE__*/_react.default.createElement("option", {
      value: "IL"
    }, "Illinois"), /*#__PURE__*/_react.default.createElement("option", {
      value: "IN"
    }, "Indiana"), /*#__PURE__*/_react.default.createElement("option", {
      value: "IA"
    }, "Iowa"), /*#__PURE__*/_react.default.createElement("option", {
      value: "KS"
    }, "Kansas"), /*#__PURE__*/_react.default.createElement("option", {
      value: "KY"
    }, "Kentucky"), /*#__PURE__*/_react.default.createElement("option", {
      value: "LA"
    }, "Louisiana"), /*#__PURE__*/_react.default.createElement("option", {
      value: "ME"
    }, "Maine"), /*#__PURE__*/_react.default.createElement("option", {
      value: "MD"
    }, "Maryland"), /*#__PURE__*/_react.default.createElement("option", {
      value: "MA"
    }, "Massachusetts"), /*#__PURE__*/_react.default.createElement("option", {
      value: "MI"
    }, "Michigan"), /*#__PURE__*/_react.default.createElement("option", {
      value: "MN"
    }, "Minnesota"), /*#__PURE__*/_react.default.createElement("option", {
      value: "MS"
    }, "Mississippi"), /*#__PURE__*/_react.default.createElement("option", {
      value: "MO"
    }, "Missouri"), /*#__PURE__*/_react.default.createElement("option", {
      value: "MT"
    }, "Montana"), /*#__PURE__*/_react.default.createElement("option", {
      value: "NE"
    }, "Nebraska"), /*#__PURE__*/_react.default.createElement("option", {
      value: "NV"
    }, "Nevada"), /*#__PURE__*/_react.default.createElement("option", {
      value: "NH"
    }, "New Hampshire"), /*#__PURE__*/_react.default.createElement("option", {
      value: "NJ"
    }, "New Jersey"), /*#__PURE__*/_react.default.createElement("option", {
      value: "NM"
    }, "New Mexico"), /*#__PURE__*/_react.default.createElement("option", {
      value: "NY"
    }, "New York"), /*#__PURE__*/_react.default.createElement("option", {
      value: "NC"
    }, "North Carolina"), /*#__PURE__*/_react.default.createElement("option", {
      value: "ND"
    }, "North Dakota"), /*#__PURE__*/_react.default.createElement("option", {
      value: "OH"
    }, "Ohio"), /*#__PURE__*/_react.default.createElement("option", {
      value: "OK"
    }, "Oklahoma"), /*#__PURE__*/_react.default.createElement("option", {
      value: "OR"
    }, "Oregon"), /*#__PURE__*/_react.default.createElement("option", {
      value: "PA"
    }, "Pennsylvania"), /*#__PURE__*/_react.default.createElement("option", {
      value: "RI"
    }, "Rhode Island"), /*#__PURE__*/_react.default.createElement("option", {
      value: "SC"
    }, "South Carolina"), /*#__PURE__*/_react.default.createElement("option", {
      value: "SD"
    }, "South Dakota"), /*#__PURE__*/_react.default.createElement("option", {
      value: "TN"
    }, "Tennessee"), /*#__PURE__*/_react.default.createElement("option", {
      value: "TX"
    }, "Texas"), /*#__PURE__*/_react.default.createElement("option", {
      value: "UT"
    }, "Utah"), /*#__PURE__*/_react.default.createElement("option", {
      value: "VT"
    }, "Vermont"), /*#__PURE__*/_react.default.createElement("option", {
      value: "VA"
    }, "Virginia"), /*#__PURE__*/_react.default.createElement("option", {
      value: "WA"
    }, "Washington"), /*#__PURE__*/_react.default.createElement("option", {
      value: "WV"
    }, "West Virginia"), /*#__PURE__*/_react.default.createElement("option", {
      value: "WI"
    }, "Wisconsin"), /*#__PURE__*/_react.default.createElement("option", {
      value: "WY"
    }, "Wyoming"), /*#__PURE__*/_react.default.createElement("option", {
      value: "non-us"
    }, "Not a U.S. resident")), /*#__PURE__*/_react.default.createElement("input", {
      type: "submit",
      value: "Join Waitlist",
      id: "joinWaitlist"
    })), /*#__PURE__*/_react.default.createElement("p", null, "By clicking \"Join the waitlist\", you acknowledge reading the", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: "https://www.wisdomtree.com/investments/privacy-policy",
      target: "_blank",
      rel: "noreferrer"
    }, "privacy policy.")));
  }

  // Open the app link via Appsflyer
  openAppLink() {
    const {
      appStoreUrl
    } = this.props;
    window.open(appStoreUrl, "_blank", "noreferrer");
  }
  // Open the waitlist with states included
  openWaitlistWithStates() {
    this.setState({
      showSelectStates: true
    });
  }
  renderWaitlistSuccess() {
    const {
      ticker
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "waitlist-success"
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "The form was sent successfully. You will receive updates on the WisdomTree Prime", /*#__PURE__*/_react.default.createElement("sup", null, "TM"), " financial app and ", ticker, " availability in your inbox. More information about WisdomTree Prime", /*#__PURE__*/_react.default.createElement("sup", null, "TM"), " is available at "), /*#__PURE__*/_react.default.createElement("a", {
      href: "http://www.wisdomtreeprime.com",
      target: "_blank",
      rel: "noreferrer"
    }, "www.wisdomtreeprime.com"), "."));
  }
  renderWaitlistLoading() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "waitlist-loading"
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: "circle-notch",
      size: "3x",
      className: "waiting-icon",
      spin: true
    }));
  }
  renderUsDigitalFundsWaitlist() {
    const {
      ticker,
      fundName
    } = this.props;
    const {
      openModal,
      showWaitlistSuccess,
      showWaitlistLoading
    } = this.state;
    let contentToShow = null;

    // Show or hide bits of content - the form or success page
    if (!showWaitlistLoading && !showWaitlistSuccess) {
      contentToShow = this.renderWaitlistForm();
    } else if (showWaitlistLoading) {
      contentToShow = this.renderWaitlistLoading();
    } else if (showWaitlistSuccess) {
      contentToShow = this.renderWaitlistSuccess();
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "buy-fund-app"
    }, ticker !== 'NONE' ? /*#__PURE__*/_react.default.createElement("div", {
      className: "trade-fund"
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: this.handleOpenModal
    }, "HOW TO BUY", ' ', ticker.toUpperCase()), /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
      open: openModal === true,
      showCloseIcon: true,
      onClose: this.handleCloseModal,
      focusTrapped: false,
      classNames: {
        overlay: 'modal-overlay',
        modal: 'choose-broker-container'
      },
      closeOnOverlayClick: true,
      closeOnEsc: true,
      center: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "choose-broker"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "intro"
    }, /*#__PURE__*/_react.default.createElement("h1", null, "How to Buy ", ticker.toUpperCase(), "?"), /*#__PURE__*/_react.default.createElement("p", null, "The", ' ', fundName, ' ', "will be available exclusively through the new WisdomTree Prime", /*#__PURE__*/_react.default.createElement("sup", null, "TM"), " financial app, targeted for launch later this year."), contentToShow), /*#__PURE__*/_react.default.createElement("div", {
      className: "footnotes"
    }, /*#__PURE__*/_react.default.createElement("p", null))))) : null);
  }
  renderUsDigitalFundsStatesWaitlist() {
    const {
      showWaitlistSuccess,
      showWaitlistLoading,
      allowedWisdomTreePrimeUsStates
    } = this.state;
    let contentToShow = null;

    // Show or hide bits of content - the form or success page
    if (!showWaitlistLoading && !showWaitlistSuccess) {
      contentToShow = this.renderWaitlistForm();
    } else if (showWaitlistLoading) {
      contentToShow = this.renderWaitlistLoading();
    } else if (showWaitlistSuccess) {
      contentToShow = this.renderWaitlistSuccess();
    }

    // Output the allowed states from WT Prime
    let statesList = null;
    if (allowedWisdomTreePrimeUsStates) {
      statesList = allowedWisdomTreePrimeUsStates.map((state, idx) => {
        return "".concat(state.shortName).concat(idx < allowedWisdomTreePrimeUsStates.length - 1 ? ', ' : '');
      });
    }
    let topContent = null;
    if ((showWaitlistSuccess || showWaitlistLoading) === false) {
      topContent = /*#__PURE__*/_react.default.createElement("p", null, "If we aren't currently available in your state, join our waitlist below.");
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "intro prime-links"
    }, /*#__PURE__*/_react.default.createElement("h1", null, "WisdomTree Prime", /*#__PURE__*/_react.default.createElement("sup", null, "TM"), " is available in:"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "states-list"
    }, statesList)), /*#__PURE__*/_react.default.createElement("p", null, "We plan on being in all 50 states soon!"), topContent, contentToShow);
  }
  renderPrimeLink() {
    const {
      ticker,
      fundName
    } = this.props;
    console.log(_primeQrCode.default);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "intro prime-links"
    }, /*#__PURE__*/_react.default.createElement("h1", null, "How to Buy ", ticker.toUpperCase(), "?"), /*#__PURE__*/_react.default.createElement("p", null, "The", ' ', fundName, ' ', "is available exclusively through the new WisdomTree Prime", /*#__PURE__*/_react.default.createElement("sup", null, "TM"), " financial app."), /*#__PURE__*/_react.default.createElement("div", {
      className: "desktop"
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Scan the QR code to download the app.")), /*#__PURE__*/_react.default.createElement("div", {
      className: "prime-qr-code"
    }, /*#__PURE__*/_react.default.createElement("img", {
      height: "150px",
      src: _primeQrCode.default.data,
      alt: "WisdomTree Prime financial app"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "prime-qr-code"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "submit-button",
      onClick: this.openAppLink
    }, "Download app"))), /*#__PURE__*/_react.default.createElement("p", null, "Available on the Google Play and Apple App stores in ", /*#__PURE__*/_react.default.createElement("span", {
      className: "states-link",
      onClick: this.openWaitlistWithStates
    }, "select states only"), "."));
  }
  renderUsDigitalFundsActive() {
    const {
      ticker
    } = this.props;
    const {
      openModal,
      showSelectStates
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "buy-fund-app"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "trade-fund"
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: this.handleOpenModal
    }, "HOW TO BUY", ' ', ticker.toUpperCase()), /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
      open: openModal === true,
      showCloseIcon: true,
      onClose: this.handleCloseModal,
      focusTrapped: false,
      classNames: {
        overlay: 'modal-overlay',
        modal: 'choose-broker-container'
      },
      closeOnOverlayClick: true,
      closeOnEsc: true,
      center: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "choose-broker"
    }, showSelectStates ? this.renderUsDigitalFundsStatesWaitlist() : this.renderPrimeLink(), /*#__PURE__*/_react.default.createElement("div", {
      className: "footnotes"
    }, /*#__PURE__*/_react.default.createElement("p", null))))));
  }

  // Render Digital Funds (wtDivisionID=3)
  renderUsDigitalFunds() {
    const {
      digitalFundsActive
    } = this.props;

    // Check if the app is active
    if (digitalFundsActive === true) {
      return this.renderUsDigitalFundsActive();
    } else {
      return this.renderUsDigitalFundsWaitlist();
    }
  }

  // Render the app
  render() {
    const {
      wtDivisionID
    } = this.props;
    switch (wtDivisionID) {
      case WT_DIVISIONS.US:
        return this.renderUsEtfs();
      case WT_DIVISIONS.USDigital:
        return this.renderUsDigitalFunds();
      default:
        return this.renderUsEtfs();
    }
  }
}
_defineProperty(BuyFund, "defaultProps", {
  brokers: _brokers.default,
  dataspanApiUrl: 'https://dataspanapi.wisdomtree.com',
  ticker: '',
  showCompare: true,
  showCompetitors: true,
  showMorningstar: false,
  showMorningstarAll: false,
  wtRegion: 'US',
  wtDivisionID: 1,
  fundName: '',
  digitalFundsActive: false,
  wtprimeApiUrl: 'https://api.wisdomtreeprimeapp.com',
  appStoreUrl: 'https://app.wisdomtreeprime.com/owuo/dir7ym2d'
});
var _default = exports.default = BuyFund;